const _toString = Object.prototype.toString
// 判断是否为对象
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]'
}
// 判断是否为数组
const isArray = arr => {
    return _toString.call(arr) === '[object Array]'
}

// 判断数组是否为[]
const isEmptyArray = arr => {
    return _toString.call(arr) === '[object Array]' && arr.length === 0
}

// 数组去重
function dedupe(array) {
    return Array.from(new Set(array))
}
// 清空数组
function clearArray(array){
    array.length=0
}
// 对象深度拷贝
function deepClone(array){
   return JSON.parse(JSON.stringify(array))
}
export  default { isPlainObject, isArray, isEmptyArray, dedupe,clearArray,deepClone }
